import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { DepartmentsService } from '../departments.service';
import {
  IDepartmentsAddPayload,
  IDepartmentsForm,
} from '../departments.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-department',
  templateUrl: './add-department.component.html',
  styleUrls: ['./add-department.component.scss'],
})
export class AddDepartmentComponent {
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    description: new FormControl('', []),
  });

  constructor(
    private dialogRef: MatDialogRef<AddDepartmentComponent>,
    private departmentsService: DepartmentsService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.departmentsService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const { name, description, id_department } = this.form
      .value as IDepartmentsForm;
    const slug = name
      .split(' ')
      .map((item) => item.toLowerCase())
      .join('_');
    const newFunctie: IDepartmentsAddPayload = {
      id_department,
      name,
      slug,
      description,
    };

    this.departmentsService
      .addDepartamente(newFunctie)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }
}
